<main>
  <loading-overlay [isLoading]="isLoading() > 0" />
  <p-toast position="top-center" />

  <div class="content">
    <div class="page__title">
      <div class="page__title_container">
        <div>
          <h1>{{ 'CashRequest_Title' | translateWF: 'Cash Requests' }}</h1>
        </div>
        <div class="page__title_buttons">
          <p-button [label]="'CashRequest_New' | translateWF: 'New request'" icon="pi pi-plus" (click)="redirectToDetails()" />
        </div>
      </div>
    </div>

    <!-- Summary ───────────────────────────────────────────────────────────── -->
    <div class="cs-summary-grid">
      <p-card data-variant="summary" [header]="'CashRequest_Drafts' | translateWF: 'Drafts'">
        <ng-template pTemplate="subtitle">{{ draftCount() }}</ng-template>
      </p-card>
      <p-card data-variant="summary" [header]="'CashRequest_Pending' | translateWF: 'Pending approval'">
        <ng-template pTemplate="subtitle">{{ pendingCount() }}</ng-template>
      </p-card>
      <p-card data-variant="summary" [header]="'CashRequest_Approved' | translateWF: 'Approved'">
        <ng-template pTemplate="subtitle">{{ approvedCount() }}</ng-template>
      </p-card>
      <p-card data-variant="summary" [header]="'CashRequest_ApprovedTotal' | translateWF: 'Approved total'">
        <ng-template pTemplate="subtitle">{{ approvedTotal() | number: '1.2-2' }}</ng-template>
      </p-card>
    </div>

    <!-- Filters + table ─────────────────────────────────────────────────────── -->
    <div class="cs-page-list-grid">
      @if (filterConfig() && showFilters()) {
        <div>
          <csl-dynamic-filters [filterConfig]="filterConfig()!" [state]="filterState" />
        </div>
      }

      <p-panel [header]="'CashRequest_Title' | translateWF: 'Cash Requests'">
        <ng-template pTemplate="icons">
          <p-button
            [label]="(showFilters() ? 'Common_Hide_Filters' : 'Common_Show_Filters') | translateWF: (showFilters() ? 'Hide Filters' : 'Show Filters')"
            [icon]="showFilters() ? 'pi pi-filter-slash' : 'pi pi-filter'"
            (click)="showFilters.set(!showFilters())"
            variant="outlined"
            size="small"
          />
        </ng-template>
        <p-card data-variant="compact">
          <p-table [value]="paginatedRequests()" [rowTrackBy]="trackById" [rowHover]="true">
            <ng-template pTemplate="header">
              <tr>
                <th>{{ 'CashRequest_Number' | translateWF: 'Number' }}</th>
                <th>{{ 'CashRequest_Week' | translateWF: 'Week' }}</th>
                <th class="text-center">{{ 'Status' | translateWF: 'Status' }}</th>
                <th class="text-right">{{ 'CashRequest_Total' | translateWF: 'Total' }}</th>
                <th>{{ 'CashRequest_RequestedBy' | translateWF: 'Requested by' }}</th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-row>
              <tr>
                <td>
                  <a class="cs-table-link font-mono text-sm" (click)="redirectToDetails(row.id)">{{ row.number }}</a>
                </td>
                <td class="text-sm">{{ row.weekStart | date: 'dd/MM/yyyy' }} – {{ row.weekEnd | date: 'dd/MM/yyyy' }}</td>
                <td class="text-center">
                  <p-tag [severity]="statusSeverity(row.status)" [value]="statusLabel(row.status) | translateWF: statusLabel(row.status)" />
                </td>
                <td class="text-right tabular-nums">{{ row.totalAmount | number: '1.2-2' }}</td>
                <td class="text-sm">{{ row.requestedBy || row.createdBy || '—' }}</td>
              </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
              <tr>
                <td colspan="5" class="text-center text-sm text-[var(--p-text-muted-color)] py-6">
                  {{ 'CashRequest_Empty' | translateWF: 'No cash requests found.' }}
                </td>
              </tr>
            </ng-template>
          </p-table>
          <p-paginator
            [rows]="pageSize()"
            [totalRecords]="totalRecords()"
            [first]="(currentPage() - 1) * pageSize()"
            (onPageChange)="onPageChange($event)"
            [rowsPerPageOptions]="[25, 50, 100]"
          />
        </p-card>
      </p-panel>
    </div>
  </div>
</main>
